import Program from "./Program";
import ProgramDetails from "./ProgramDetails/ProgramDetails";
import { useAppSelector } from "@/stores/hook";

export default function ProgramIndex() {
  const { isProgramDetails } = useAppSelector(
    (state) => state.academyFunctional
  );

  if (isProgramDetails) {
    return (
      <div className="m-4">
        <ProgramDetails />
      </div>
    );
  }

  return (
    <div className="m-4">
      <Program />
    </div>
  );
}
